import { lazy, object, string } from "yup";

export const doneRevisionValidationSchema = (isRequired: boolean) =>
    lazy((value) => {
        return object().shape({
            reason: string().nullable().notRequired(),
            observations: string().nullable().notRequired(),
        });
    });



export const doneRevisionDefaultValues = (observations: string) => {
    return {
        reason: null,
        observations: observations ?? null
    }
};